import { useSelector } from "react-redux";
import {
  selectAnnouncementsList,
  selectAnnouncementsListLoading,
} from "Redux/Announcements/slice";
import { categoryColors } from "./constants";
import { Category964Enum } from "Shared/Types/fleetmanagementapi";

export const useAnnouncements = () => {
  const loading = useSelector(selectAnnouncementsListLoading);
  const announcements = useSelector(selectAnnouncementsList);
  const getCategoryColor = (category: Category964Enum | undefined) =>
    (category && categoryColors[category]) || "default";

  return { loading, announcements, getCategoryColor };
};
